module.exports = __webpack_public_path__ + "img/updatedThawer.653d487e.png";